// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-gHuTf";
var _4 = "header-m6QnR";
var _5 = "header__wrapper-eFAfU";
var _6 = "title-1-Nyu";
var _7 = "footer-3ZPTv";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "header", _5 as "header__wrapper", _6 as "title", _7 as "footer" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "header": _4, "header__wrapper": _5, "title": _6, "footer": _7 }
